import { React } from 'react';

// mui
import { Box, Autocomplete, Typography, TextField } from '@mui/material';

function AdminAutocomplete(props) {
    return (
        <Autocomplete
            sx={{ m: 0, p: 0, width: '100%' }}
            size='small'
            options={props.options}
            getOptionLabel={(option) => option.label}

            renderOption={(props, option) => (
                <Box component='li' {...props}>
                    <Typography sx={{ fontSize: '14px' }}>{option.label}</Typography>
                </Box>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant='standard'
                    slotProps={{
                        htmlInput: {
                            ...params.inputProps,
                            style: {
                                fontSize: '14px',
                            },
                            maxLength: props.maxDesc,
                        },
                        inputLabel: {
                            ...params.inputProps,
                            style: {
                                fontSize: '14px',
                            },
                        },
                    }}
                />
            )}
            onChange={props.onChange}
        />
    );
}

export { AdminAutocomplete };
